import type { MessageKey } from '@eluve/i18n';

/** Translation key for the title displayed above the insights content. */
export const INSIGHTS_TITLE_KEY =
  'appointment.insights.title' as const satisfies MessageKey;

/**
 * Translation key for the tooltip explaining what AI Insights are to users.
 * Used in both the InsightsPanel title and CollapsibleInsightsPanel header.
 */
export const AI_INSIGHTS_TOOLTIP_KEY =
  'appointment.insights.tooltip' as const satisfies MessageKey;
